<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Tools</h4>
            <div class="row">
              <div class="col-md-12">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a
                        class="nav-link active show"
                        id="team-announcements-tab"
                        data-toggle="tab"
                        href="#team-announcements"
                        role="tab"
                        aria-controls="up"
                    >Temporary Links</a
                    >
                  </li>
                  <li class="nav-item" v-if="user.userType === 'admin' || user.userType === 'super-admin'">
                    <a
                        class="nav-link"
                        data-toggle="tab"
                        href="#firebase_backups"
                        role="tab"
                        aria-controls="up"
                    >Firebase Backups</a>
                  </li>
                  <li class="nav-item" v-if="user.userType === 'admin' || user.userType === 'super-admin'">
                    <a
                        class="nav-link"
                        data-toggle="tab"
                        href="#wpo_status"
                        role="tab"
                        aria-controls="up"
                    >WPO Status</a>
                  </li>
                  <li class="nav-item" v-if="user.userType === 'admin' || user.userType === 'super-admin'">
                    <a
                        class="nav-link"
                        data-toggle="tab"
                        href="#cron_logs"
                        role="tab"
                        aria-controls="up"
                    >Cron Logs</a>
                  </li>
                  <li class="nav-item" v-if="user.userType === 'admin' || user.userType === 'super-admin'">
                    <a
                        class="nav-link"
                        data-toggle="tab"
                        href="#mass-outages"
                        role="tab"
                        aria-controls="up"
                    >Mass Outages</a>
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        data-toggle="tab"
                        href="#vps-backups"
                        role="tab"
                        aria-controls="up"
                    >VPS Backups</a>
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        data-toggle="tab"
                        href="#cfLogs"
                        role="tab"
                        aria-controls="up"
                    >Cloudflare Logs</a>
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        data-toggle="tab"
                        href="#backups"
                        role="tab"
                        aria-controls="up"
                    >Backups</a>
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        data-toggle="tab"
                        href="#audit-hostname"
                        role="tab"
                        aria-controls="up"
                    >Hostname DNS Audit</a>
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        data-toggle="tab"
                        href="#non-wpo-monitors"
                        role="tab"
                        aria-controls="up"
                    >Non-WPO Zabbix Monitors</a>
                  </li>
                  <li class="nav-item">
                    <a
                        @click="selectedTab = 'newBackupSystem'"
                        class="nav-link"
                        data-toggle="tab"
                        href="#new-backup-system"
                        role="tab"
                        aria-controls="up"
                    >New Backup System</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body" style="padding-top: 0 !important">
            <div class="tab-content customer-table">
              <div id="team-announcements" class="tab-pane active show">
                <temp-links />
              </div>
              <div id="firebase_backups" class="tab-pane fade" v-if="user.userType === 'admin' || user.userType === 'super-admin'">
                <firebase-backups/>
              </div>
              <div id="wpo_status" class="tab-pane fade" v-if="user.userType === 'admin' || user.userType === 'super-admin'">
                <ServiceStatus/>
              </div>
              <div id="cron_logs" class="tab-pane fade" v-if="user.userType === 'admin' || user.userType === 'super-admin'">
                <CronLogs></CronLogs>
              </div>
              <div id="mass-outages" class="tab-pane fade" v-if="user.userType === 'admin' || user.userType === 'super-admin'">
                <MassOutages />
              </div>
              <div id="vps-backups" class="tab-pane fade">
                <vpsBackups/>
              </div>
              <div id="cfLogs" class="tab-pane fade">
                <cf-logs ref="cfLog" @onViewModal="onViewModal"/>
              </div>
              <div id="backups" class="tab-pane fade">
                <backups ref="backups"/>
              </div>
              <div id="audit-hostname" class="tab-pane fade">
                <AuditHostname ref="auditHostname"/>
              </div>
              <div id="non-wpo-monitors" class="tab-pane fade">
                <create-non-w-p-o-monitors></create-non-w-p-o-monitors>
              </div>
              <div v-if="selectedTab === 'newBackupSystem'" id="new-backup-system" class="tab-pane fade">
                <new-backup-system></new-backup-system>
              </div>
            </div>
          </div>
          <div class="stepModal position-relative">
            <div class="modal fade" id="modal" tabindex="-1" role="dialog" aria-labelledby="modal">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="notesModalHeader">View Details</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body bodyTable">
                    <table class="table table-striped table-responsive">
                      <thead>
                      <th>Domain</th>
                      <th class="text-center">Status</th>
                      <th class="text-center">Username</th>
                      <th class="text-center">API Key</th>
                      <th class="text-center">Zone</th>
                      <th class="text-center">Action</th>
                      </thead>
                      <tbody>
                      <tr v-for="(row, index) of modifiedDomains" :key="index">
                        <td class="flex-column">
                          <span>{{row.domain}}</span>
                          <span v-if="row.error && !row.error.success" class="text-danger mt-5">Re: <span class="text-dark italic">{{row.error.message}}</span></span>
                        </td>
                        <td class="text-center">
                          <i v-if="row.apiResponse && row.apiResponse.success" class="fa fa-check-circle text-success"></i>
                          <i v-else-if="row.error && !row.error.success" class="fa fa-times-circle text-danger"></i>
                        </td>
                        <td class="text-center"><span class="make-cursor-pointer" data-toggle="tooltip" data-placement="top" data-html="true" :title="row.cloudflare.username" @click="doCopy(row.cloudflare.username)">{{row.cloudflare.username.substring(0,15)}}...</span></td>
                        <td class="text-center"><span class="make-cursor-pointer" data-toggle="tooltip" data-placement="top" data-html="true" :title="row.cloudflare.apiKey" @click="doCopy(row.cloudflare.apiKey)">{{row.cloudflare.apiKey.substring(0,15)}}...</span></td>
                        <td class="text-center"><span class="make-cursor-pointer" data-toggle="tooltip" data-placement="top" data-html="true" :title="row.cloudflare.zone_id" @click="doCopy(row.cloudflare.zone_id)">{{row.cloudflare.zone_id.substring(0,15)}}...</span></td>
                        <td class="text-center">
                          <button data-toggle="tooltip" data-placement="top" data-html="true" @click="retry({index, domain: row.domain})" title="Retry" v-if="row.error && !row.error.success" class="btn btn-sm btn-primary">
                            <i v-if="selectedIndex === index" class="fa fa-spin fa-spinner"></i>
                            <i v-else class="fa fa-repeat"></i>
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-dark">Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <add-c-f-filtering-modal ref="cfFilteringModal"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import TempLinks from "@/components/Admin/Tools/tempLinks";
import FirebaseBackups from "@/components/Admin/Tools/firebaseBackups";
import ManualTask from "@/components/Admin/Sales/ManualTask.vue";
import ServiceStatus from "@/components/Admin/Tools/ServiceStatus.vue";
import CronLogs from "@/components/Admin/Tools/cronLogs.vue";
import MassOutages from "@/components/Admin/Tools/MassOutages.vue";
import vpsBackups from "@/components/Admin/Tools/vpsBackups.vue";
import cfLogs from "@/components/Admin/Tools/cfLogs.vue";
import copyButtonMixin from "@/mixins/copyButtonMixin";
import AddCFFilteringModal from "@/components/Admin/Tools/addCFFilteringModal.vue";
import backups from "@/components/Admin/Tools/backups.vue";
import AuditHostname from "@/components/Admin/Tools/AuditHostname.vue";
import createNonWPOMonitors from "@/components/Admin/Tools/createNonWPOZabbixMonitors.vue";
import newBackupSystem from "@/components/Admin/Tools/newBackupSystem.vue";
export default {
  name: "index",
  components: {
    newBackupSystem,
    AddCFFilteringModal,
    backups,
    ServiceStatus, ManualTask, TempLinks, FirebaseBackups, MassOutages, CronLogs, vpsBackups, cfLogs, AuditHostname, createNonWPOMonitors},
  mixins: [copyButtonMixin],
  data() {
    return {
      selectedTab: '',
      message: '',
      title: '',
      loading: '',
      key: '',
      cfLog: { domains: []},
      selectedIndex: -1
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    modifiedDomains() {
      return this.cfLog.domains
    }
  },
  methods: {
    async retry(row) {
      try {
        this.loading = true;
        this.selectedIndex = row.index
        const ref = await this.$http.post('provider/retry_adding_cf', {
          plan: this.cfLog.plan,
          domain: row.domain,
          custId: this.cfLog.uid,
          cfLogId: this.cfLog.id
        })
        console.log('response from api', ref)
        await this.$refs.cfLog.updateModalData(this.cfLog.id)
      } catch (e) {
        console.log('error while retrying', e)
      } finally {
        this.loading = false;
        this.selectedIndex = -1

      }
    },
    onViewModal(data) {
      console.log('ere', data)
      if(data.type === 'viewModal') {
        this.cfLog = data;
        $("#modal").modal('show');
        $('.modal-backdrop').removeClass("modal-backdrop");
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      } else if(data.type === 'addCFRequestFiltering') {
        this.$refs.cfFilteringModal.load()
      }
    }
  }
}
</script>


<style scoped lang="scss">
.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5b7cfb;
}
.notes-section {
  background-color: #ef8057;
  color: white;
  border-radius: 3px;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  hr {
    border-top: 1px solid rgba(255,255,255,.5);
  }
}
table{
  tr {
    .task-width {
      width:70%;
    }
    td {
      /deep/  p {
        margin: 0 !important;
      }
    }
  }
}
hr {
  &.h-3 {
    border-top: 3px solid rgba(0,0,0,.1);
  }
}
.pagination{
  display: inline-flex !important;
}
.cf-status-icons {
  i {
    font-size: 25px;
    margin: 0 !important;
    &.disabled {
      color: #7E7E7E;
    }

    &.enabled {
      color: #47f260;
    }

    &.yellow {
      color: #f2b61d;
    }
    &.default {
      color: currentColor;
    }
    &:hover{
      background-color:transparent !important;
      color: currentColor !important;
    }
  }
}
.cpy-btn{
  margin: 0;
}
.fs-10{
  font-size: 10px;
}
.h-43{
  height:43px;
}
.domain-card{
  background: #f0f0f4;
  box-shadow: none;
  border-radius: 8px !important;
  &:hover{
    box-shadow: 0 6px 10px 3px rgba(0, 0, 0, 0.15);;
  }
  .collapse-btn{
    margin-top: 0.5rem !important;
  }
  .domain-head{
    display: flex;
    justify-content: space-between;
    .h5-m0 {
      margin: 0;
    }
    .ul-m0{
      margin: 0;
    }
  }
  .domain-info{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .badge{
      text-transform: none !important;
    }
  }
}
.bl-bt{
  display: flex;
  align-items: flex-end;
  button {
    margin: 0 !important;
  }
}
.cursor-pointer{
  cursor: pointer;
}
pre{
  display: inline-block;
  margin-bottom: 0px;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.italic{
  font-style: italic;
}
.bodyTable{
  max-height: 700px !important;
  overflow-y: auto;
}
@media (min-width: 992px) {
  .modal-lg {
    max-width: 1000px;
  }
}
</style>

